import { useTheme } from 'next-themes';
import { socialProfiles } from '@/lib/socials';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  return (
    <footer className="bg-warm-cream-50 dark:bg-background border-t border-warm-cream-300 dark:border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-5 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <a href="/" className="flex items-center mb-4 group">
              <img
                src={isDark ? "/logo-dark.svg" : "/logo.svg"}
                alt="JOYLO"
                className="h-12 lg:h-14 transition-transform group-hover:scale-105"
              />
            </a>

            <p className="text-soft-gray-600 dark:text-gray-400 mb-6 max-w-md">
              Turn your wildest ideas into production apps. Build with AI. Scale with certified architects.
            </p>

            <ul className="flex flex-wrap gap-x-4 gap-y-2">
              {socialProfiles.map((social) => (
                <li key={social.name}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer me"
                    aria-label={`Joylo on ${social.name} (${social.handle})`}
                    className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white text-sm transition-colors"
                  >
                    {social.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold text-ink-blue-900 dark:text-white mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <a href="/pricing" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="/production-guarantee" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white transition-colors">
                  Production Guarantee
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-ink-blue-900 dark:text-white mb-4">Company</h3>
            <ul className="space-y-3">
              {/* <li><a href="/#about" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white transition-colors">About</a></li> */}
              <li><a href="/blog" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white transition-colors">Blog</a></li>
              <li><a href="/help#contact" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold text-ink-blue-900 dark:text-white mb-4">Support</h3>
            <ul className="space-y-3">
              <li>
                <a href="/help" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white transition-colors">
                  Help Center
                </a>
              </li>
              <li><a href="/help?subject=Bug%20Report#contact" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white transition-colors">Report an issue</a></li>
              <li><a href="#" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white transition-colors">Community</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-warm-cream-300 dark:border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-soft-gray-600 dark:text-gray-400 text-sm">
            © {currentYear} Joylo. All rights reserved.
          </p>

          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="/privacy" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white text-sm transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white text-sm transition-colors">Terms of Service</a>
            <a href="/privacy#cookies" className="text-soft-gray-600 dark:text-gray-400 hover:text-ink-blue-900 dark:hover:text-white text-sm transition-colors">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
